<template>
    <div class="bonus-rule">
        <ru v-if="lang=='ru'" />
        <fr v-else-if="lang=='fr'" />
        <es v-else-if="lang=='es'" />
        <en v-else />
    </div>
</template>
<script>
import Vue from 'vue';

import Ru from './ru.vue';
import En from './en.vue';
import Fr from './fr.vue';
import Es from './es.vue';

export default {
    name: 'bonus-rules-mailing',
    components: { Ru, En, Fr, Es },
    computed: {
        lang() {
            return Vue.state.lang.currentLang;
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/index.vue